module.exports = __webpack_public_path__ + "img/icoon_zintuigenactiveren_small.9c288336.svg";